import {
	attributeMaps,
	colorsMap,
	flavorMap,
	modalitiesMap,
	NameAttributes,
	objectivesMap,
	sizeMap,
} from '@/entities/api/products/product'

const getAttributeDisplayValue = (attribute: any): string => {
	try {
		const normalized = normalizeAttribute(attribute)
		if (!normalized) return ''

		const values = normalized.value
		const names = normalized.name

		if (values.length === 0) return ''

		const displayValues = values.map((value: any, index: number) => {
			const name = names[index] || names[0]
			const valueStr = String(value)

			switch (name) {
				case NameAttributes.COLOR:
					return colorsMap[valueStr as keyof typeof colorsMap]
						? valueStr
						: valueStr
				case NameAttributes.SIZE:
					return sizeMap[valueStr as keyof typeof sizeMap]
						? `${valueStr} (${sizeMap[valueStr as keyof typeof sizeMap]})`
						: valueStr
				case NameAttributes.FLAVOR:
					return flavorMap[valueStr as keyof typeof flavorMap] || valueStr
				case NameAttributes.OBJECTIVE:
					return (
						objectivesMap[valueStr as keyof typeof objectivesMap] || valueStr
					)
				case NameAttributes.MODALITY:
					return (
						modalitiesMap[valueStr as keyof typeof modalitiesMap] || valueStr
					)
				default:
					return (
						attributeMaps[valueStr as keyof typeof attributeMaps] || valueStr
					)
			}
		})

		return displayValues.join(' / ')
	} catch (error) {
		const fallbackValue = Array.isArray(attribute.value)
			? attribute.value[0]
			: attribute.value
		return (
			attributeMaps[String(fallbackValue) as keyof typeof attributeMaps] ||
			String(fallbackValue || '')
		)
	}
}

const normalizeAttribute = (attribute: any) => {
	if (!attribute) return null

	const names = Array.isArray(attribute.name)
		? attribute.name
		: [attribute.name]
	const values = Array.isArray(attribute.value)
		? attribute.value
		: [attribute.value]
	const references = Array.isArray(attribute.reference)
		? attribute.reference
		: [attribute.reference]

	if (names.length !== values.length) {
		const valuesToPad = names.length - values.length
		for (let i = 0; i < valuesToPad; i++) {
			values.push(values[0] || '')
		}
	}

	if (names.length !== references.length) {
		for (let i = references.length; i < names.length; i++) {
			const name = names[i]
			const value = values[i]
			let referenceValue = String(value)

			switch (name) {
				case NameAttributes.COLOR:
					referenceValue =
						colorsMap[value as keyof typeof colorsMap] || String(value)
					break
				case NameAttributes.SIZE:
					referenceValue =
						sizeMap[value as keyof typeof sizeMap] || String(value)
					break
				case NameAttributes.FLAVOR:
					referenceValue =
						flavorMap[value as keyof typeof flavorMap] || String(value)
					break
				case NameAttributes.OBJECTIVE:
					referenceValue =
						objectivesMap[value as keyof typeof objectivesMap] || String(value)
					break
				case NameAttributes.MODALITY:
					referenceValue =
						modalitiesMap[value as keyof typeof modalitiesMap] || String(value)
					break
			}

			references.push(referenceValue)
		}
	}

	return {
		...attribute,
		name: names,
		value: values,
		reference: references,
	}
}

export { normalizeAttribute, getAttributeDisplayValue   }
